// extracted by mini-css-extract-plugin
export default {"draftAnnouncement":"index_draftAnnouncement__fOZL5"};